import api from "@/lib/api";

export const expertService = {
  search: (topic) => api.post("/experts/search", { topic }).then((r) => r.data),
  narrate: (text) => api.post("/experts/narrate", { text }).then((r) => r.data.audio),
  listCollected: () => api.get("/experts/collected").then((r) => r.data.experts),
  collect: (expert, topic) => api.post("/experts/collected", { expert, topic }).then((r) => r.data),
  removeCollected: (expertId) => api.delete(`/experts/collected/${expertId}`).then((r) => r.data),
  listCourses: () => api.get("/experts/courses").then((r) => r.data.courses),
  generateCourse: (expert, topic) => api.post("/experts/course", { expert, topic }).then((r) => r.data.course),
};
